export const TIME_ENTRY_DESCRIPTION_REQUIREMENT_ALL = 'all';
export const TIME_ENTRY_DESCRIPTION_REQUIREMENT_BILLABLE = 'billable';
export const TIME_ENTRY_DESCRIPTION_REQUIREMENT_NONE = 'none';
